export class Notice {
    constructor() {
        this.container = null;
        this.el = null;
        this.className = 'notice-item';
        this._timeout = 7000;
        this._timer = null;
        this.addContainer();
    }

    info(text, options) {
        this.create('notice-item-info', text, options);
    }

    warn(text, options) {
        this.create('notice-item-warn', text, options);
    }

    error(text, options) {
        this.create('notice-item-error', text, options);
    }

    success(text, options) {
        this.create('notice-item-success', text, options);
    }

    addContainer() {
        let container = document.getElementById('notice-container-block');
        if (!container) {
            container = document.createElement('div');
            container.id = 'notice-container-block';
            document.body.appendChild(container);
        }

        this.container = container;
    }

    create(type, text, options) {
        if (typeof text !== 'string') {
            throw new Error('required parameter text');
        }

        options = options || {};

        const notice = document.createElement('div');
        notice.className = this.className;
        notice.classList.add(type);
        notice.textContent = text;
        notice.setAttribute('role', 'alert');

        this.container.appendChild(notice);
        this.el = notice;
        this._timeout = options.timeout || this._timeout;
        this.el.addEventListener('click', () => this.hide());
        this.setDuration(this._timeout);
    }

    setDuration(timeout) {
        if (typeof timeout === 'number') {
            this._timer = setTimeout(() => this.hide(), this._timeout);
        }
    }

    hide() {
        this.el.classList.add('notice-fade-out');
        this.el.addEventListener('animationend', () => this.remove(), false);
    }

    remove() {
        clearTimeout(this._timer);
        this.el.removeEventListener('animationend', () => null, false);
        this.container.removeChild(this.el);
        this.el = null;
    }
}
